import { writable } from 'svelte/store';

// export const user = writable({});

const storage_users = localStorage.getItem("users");

export const users = writable(storage_users ? JSON.parse(storage_users) : []); // storage_user ? JSON.parse(storage_user) : {}

users.subscribe(value => {
    localStorage.setItem("users", JSON.stringify(value));
});